import Link from 'next/link';

import { SymbolLeaderboardRanking } from '@flipster/apis/v1/symbol-leaderboard/types';
import Formatted from '@flipster/react/design-utils/formatted';
import Crown1StColorIcon from '@flipster/react/icon/generated/Crown1StColorIcon';
import Crown2NdColorIcon from '@flipster/react/icon/generated/Crown2NdColorIcon';
import Crown3RdColorIcon from '@flipster/react/icon/generated/Crown3RdColorIcon';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';
import { UsdtPrecision } from '@flipster/utils/constants/currency';
import segment from '@flipster/utils/segment';
import { CommunityEvent } from '@flipster/utils/segment/events/community';

export const RankingCard = ({ ranking, rank }: { ranking: SymbolLeaderboardRanking; rank: number }) => {
  return (
    <Link
      href={`/user/profile/${ranking.userProfileId}`}
      onClick={() => {
        segment.track(CommunityEvent.FeedTopPnlTraderClick, {
          profile_id: ranking.userProfileId,
          profile_ranking: rank.toString(),
          profile_username: ranking.nickname,
          realized_pnl: Number(ranking.pnl),
          realized_pnl_percentage: Number(ranking.pnlPct),
        });
      }}
    >
      <div
        className={hstack({
          gap: 12,
          p: '8px 4px',
          rounded: 8,
          _hover: {
            bg: 'background.interaction.hover',
          },
        })}
      >
        <div className={css({ flexShrink: 0 })}>
          <RankingIcon rank={rank} />
        </div>
        <div>
          <p className={css({ textStyle: 'Text/S/Strong', color: 'content.default.level-3' })}>{ranking.nickname}</p>
          <div
            className={hstack({
              gap: 4,
              textStyle: 'Text/M/Monospace/Regular',
              color: 'content.default.level-5',
              flexWrap: 'wrap',
            })}
          >
            <Formatted.Number value={ranking.pnl} precision={UsdtPrecision} toFixed withComma withPlus withColor />
            <Formatted.Percent value={ranking.pnlPct} toFixed withComma withPlus withColor withParentheses />
          </div>
        </div>
      </div>
    </Link>
  );
};

const RankingIcon = ({ rank }: { rank: number }) => {
  switch (rank) {
    case 1:
      return <Crown1StColorIcon size={26} />;
    case 2:
      return <Crown2NdColorIcon size={26} />;
    case 3:
      return <Crown3RdColorIcon size={26} />;
  }
  return null;
};
